// Sidebar actions

export const UPDATE_STEP = "UPDATE_STEP";
export const CLEAR_EVERYTHING = "CLEAR_EVERYTHING";

function updateStep(args) {
  return {
    type: UPDATE_STEP,
    ...args
  };
}

export { updateStep };



// WEBPACK FOOTER //
// ./src/pretravel/components/Sidebar/action.js